// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';
import TaxesType from '../../constants/TaxesType';

export default class ProductPrice extends ApiObject {

  /**
   * true if this product can be bought for the mode described by this Price object
   */
  available: boolean = false;

  /**
   * VAT in percent, 10.0 is 10.00%
   */
  vat: number = 5.5;

  priceIncludingTax: number = 0;

  happyHoursAvailable: boolean = false;

  priceIncludingTaxHappyHours: number = 0;

  postJsonAssignation(data: Object) {
  }

  isValid(): boolean {
    return this.available === false || (
      !_.isNaN(parseFloat(this.priceIncludingTax))
      // Deactivate vat verification for now because POS menu returns null
      // TODO: vat isValid POS PayMyTable
      // && TaxesType.isValid(this.vat)
    );
  }

  /**
   * Set the given price on priceIncludingTax by adding the tax
   */
  setPriceWithoutTax(price: number) {
    const vatAdd = _.isNull(this.vat) ? 0 : price * (this.vat / 100);
    this.priceIncludingTax = price + vatAdd;
  }

  /**
   * Set the given price on priceIncludingTax
   */
  setPriceWithTax(price: number) {
    this.priceIncludingTax = price;
  }

}
